const pairPurple = {
  main: "#702c90",
  light: "#a244cf",
  dark: "#562170",
};

export { pairPurple };
